import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={80}
    height={90.38}
    viewBox="0 0 80 90.38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M72.6511 8.51775H65.211V6.3742C65.211 2.8528 61.9205 0 57.8647 0C53.8089 0 50.5184 2.85506 50.5184 6.3742V8.51775H29.479V6.3742C29.479 2.8528 26.1885 0 22.1327 0C18.0769 0 14.7864 2.85506 14.7864 6.3742V8.51775H7.34633C3.28789 8.51775 0 11.3728 0 14.8919V83.9962C0 87.5176 3.29049 90.3704 7.34633 90.3704H72.6537C76.7121 90.3704 80 87.5153 80 83.9962V14.8919C79.9974 11.3706 76.7069 8.51775 72.6511 8.51775Z"
      fill="url(#paint0_linear_12193_14542)"
    />
    <path
      d="M35.9246 21.3343H34.6722C34.0981 21.3343 33.6286 21.8039 33.6286 22.3779V23.7346H30.9674C29.4018 23.7346 28.1497 24.9871 28.1497 26.5523V41.9463C28.1497 43.5118 29.4021 44.764 30.9674 44.764H49.0749C50.6404 44.764 51.8925 43.5115 51.8925 41.9463V26.5523C51.8925 24.9867 50.6401 23.7346 49.0749 23.7346H46.4136V22.3779C46.4136 21.8039 45.944 21.3343 45.37 21.3343H44.1176C43.5435 21.3343 43.074 21.8039 43.074 22.3779V23.7346L36.9683 23.7342V22.3776C36.9683 21.8035 36.4987 21.334 35.9247 21.334L35.9246 21.3343ZM49.9097 29.9444V41.9464C49.9097 42.416 49.5442 42.7815 49.0747 42.7815H30.9672C30.4976 42.7815 30.1322 42.416 30.1322 41.9464V29.9444H49.9097Z"
      fill="white"
    />
    <path
      d="M44.641 35.5269H47.3543C47.7197 35.5269 48.0327 35.2138 48.0327 34.8484V32.8133C48.0327 32.4478 47.7197 32.1348 47.3543 32.1348H44.6406C44.2752 32.1348 43.9622 32.4478 43.9622 32.8133V34.8484C44.0146 35.2135 44.2756 35.5269 44.641 35.5269Z"
      fill="white"
    />
    <path
      d="M38.7031 35.5269H41.4168C41.7822 35.5269 42.0952 35.2138 42.0952 34.8484V32.8133C42.0952 32.4478 41.7822 32.1348 41.4168 32.1348H38.7031C38.3377 32.1348 38.0247 32.4478 38.0247 32.8133V34.8484C38.0247 35.2135 38.3377 35.5269 38.7031 35.5269Z"
      fill="white"
    />
    <path
      d="M32.6927 35.5269H35.3543C35.7197 35.5269 36.0328 35.2138 36.0328 34.8484V32.8133C36.0328 32.4478 35.7197 32.1348 35.3543 32.1348H32.6406C32.2752 32.1348 31.9622 32.4478 31.9622 32.8133V34.8484C32.0146 35.2135 32.3276 35.5269 32.6927 35.5269H32.6927Z"
      fill="white"
    />
    <path
      d="M44.641 40.9019H47.3543C47.7197 40.9019 48.0327 40.5888 48.0327 40.2234V38.1883C48.0327 37.8228 47.7197 37.5098 47.3543 37.5098H44.6406C44.2752 37.5098 43.9622 37.8228 43.9622 38.1883V40.2234C44.0146 40.5885 44.2756 40.9019 44.641 40.9019Z"
      fill="white"
    />
    <path
      d="M38.7031 40.9019H41.4168C41.7822 40.9019 42.0952 40.5888 42.0952 40.2234V38.1883C42.0952 37.8228 41.7822 37.5098 41.4168 37.5098H38.7031C38.3377 37.5098 38.0247 37.8228 38.0247 38.1883V40.2234C38.0247 40.5885 38.3377 40.9019 38.7031 40.9019Z"
      fill="white"
    />
    <path
      d="M32.6927 40.9019H35.3543C35.7197 40.9019 36.0328 40.5888 36.0328 40.2234V38.1883C36.0328 37.8228 35.7197 37.5098 35.3543 37.5098H32.6406C32.2752 37.5098 31.9622 37.8228 31.9622 38.1883V40.2234C32.0146 40.5885 32.3276 40.9019 32.6927 40.9019H32.6927Z"
      fill="white"
    />

    <defs>
      <linearGradient
        id="paint0_linear_12193_14542"
        x1={0}
        y1={90.3706}
        x2={80}
        y2={90.3706}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0989583} stopColor="#BC9B6A" />
        <stop offset={1} stopColor="#947550" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
